// extracted by mini-css-extract-plugin
module.exports = {"section":"VerifyCodePage_section__1JsIJ","eyebrow":"VerifyCodePage_eyebrow__L0N9w","subheading":"VerifyCodePage_subheading__rYckW"};